import type { ReactNode } from 'react';

import { Spinner } from '~components/ui/spinner';

type LoaderProps = {
  orientation?: 'horizontal' | 'vertical';
  children?: ReactNode;
};

const Loader = ({ children, orientation = 'horizontal' }: LoaderProps) => {
  return (
    <div className={`inline-flex items-center gap-1 ${orientation === 'vertical' ? 'flex-col' : 'flex-row'}`}>
      <Spinner aria-label="Loading content" />
      {children && <div className="text-lg">{children}</div>}
    </div>
  );
};

export { Loader };
